module.exports = __webpack_public_path__ + "static/media/10b.818ea501.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/10b.jpg
// module id = 573
// module chunks = 0